module.exports = "<div class=\"animated-router-outlet\" [@fadeInOut]=\"routeAnimations(outlet)\">\n\t<router-outlet #outlet=\"outlet\"></router-outlet>\n</div>"